import { FieldDefinition } from "./fieldDefinitions";

export interface AllergyDto {
  allergyId: number;
  allergyDescr: string;
  allergyRemarks?: string;
}

export const allergyKeyId = "allergyId" as const;

export type AllergyFormData = {
  allergyDescr: string;
  allergyRemarks?: string;
};

export const allergyFields: FieldDefinition<AllergyFormData>[] = [
  {
    name: "allergyDescr",
    label: "Περιγραφή Αλλεργίας",
    type: "text",
    required: true,
  },
  {
    name: "allergyRemarks",
    label: "Παρατηρήσεις",
    type: "text",
    required: false,
  },
] as const;

export const allergyFilters = allergyFields.filter((f) =>
  ["allergyDescr", "allergyRemarks"].includes(f.name as string),
);


export const allergyFormData: (keyof AllergyFormData)[] = [
  "allergyDescr",
  "allergyRemarks",
];
